import { Scene, GameObjects } from 'phaser';
import { Utils } from '../services/Utils';
import i18next from 'i18next';
import { Words } from '../services/Words';

export class MainMenu extends Scene
{
    background: GameObjects.Image;
    canPressKeys: boolean;
    languageIcon: GameObjects.Image;

    space: Phaser.Input.Keyboard.Key;
    //t: Phaser.Input.Keyboard.Key;
    l: Phaser.Input.Keyboard.Key;
    

    constructor ()
    {
        super('MainMenu');
    }

    create () 
    {
        if (this.input.keyboard) {
            this.space = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
            //this.t = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.S);
            this.l = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.L);
        }

        this.canPressKeys = false;
        this.background = this.add.image(512, 384, 'background');

        this.add.text(512, 300, 'Plabble', {
            fontFamily: 'MyLeaf', fontSize: 38*3, color: '#61b85d',
            stroke: '#5a9458', strokeThickness: 8*2,
            align: 'center'
        }).setOrigin(0.5);

        this.time.delayedCall(3000, () => {
            const pad = this.input.gamepad?.getPad(0);
            if (pad) {
                this.add.text(512, 460, i18next.t('menustart') + (Utils.getTutorialDone() ? i18next.t('menustarttut'): ''), {
                    fontFamily: 'Arial Black', fontSize: 38, color: '#ffffff',
                    stroke: '#000000', strokeThickness: 8,
                    align: 'center'
                }).setOrigin(0.5);
    
                this.add.text(512, 650, i18next.t('setlanguage'), {
                    fontFamily: 'Arial Black', fontSize: 38, color: '#ffffff',
                    stroke: '#000000', strokeThickness: 8,
                    align: 'center'
                }).setOrigin(0.5);
            }
            else {
                this.add.text(512, 460, i18next.t('menustartkeyboard') + (Utils.getTutorialDone() ? i18next.t('menustarttutkeyboard'): ''), {
                    fontFamily: 'Arial Black', fontSize: 38, color: '#ffffff',
                    stroke: '#000000', strokeThickness: 8,
                    align: 'center'
                }).setOrigin(0.5);
    
                this.add.text(512, 650, i18next.t('setlanguagekeyboard'), {
                    fontFamily: 'Arial Black', fontSize: 38, color: '#ffffff',
                    stroke: '#000000', strokeThickness: 8,
                    align: 'center'
                }).setOrigin(0.5);
            }

            this.languageIcon = this.add.image(512, 600, i18next.language);
            this.languageIcon.scale = 0.1;
    
            this.canPressKeys = true;
        });
        
    }

    update() {
        if (!this.canPressKeys) return;

        for (let i = 0; i < 4; i++) {
            const pad = this.input.gamepad?.getPad(i);
            if (pad) {
                if (pad.A) {
                    this.scene.start('Game');
                }
                if (pad.X) {
                    Utils.setTutorialDone(false);
                    this.scene.start('Game');
                }
                if (pad.Y) {
                    i18next.changeLanguage(i18next.language == 'en' ? 'nl' : 'en', () => {
                        console.log(i18next.language);
                        //Translations.init();
                        Words.init();
                        this.scene.start('MainMenu');
                    });
                    
                }
            }
        }

        if (this.space.isDown) {
            Utils.setTutorialDone(true);
            this.scene.start('Game');
        }
        // if (this.t.isDown) {
        //     Utils.setTutorialDone(false);
        //     this.scene.start('Game');
        // }
        if (this.l.isDown) {
            this.canPressKeys = false;
            i18next.changeLanguage(i18next.language == 'en' ? 'nl' : 'en', () => {
                console.log(i18next.language);
                //Translations.init();
                Words.init();
                this.scene.start('MainMenu');
            });
        }
    }
}
